import { Record } from 'immutable';

import type { accountsTypes } from 'app-components/flux/accounts';

export type AccountBalances = {
  accountId: string;
  accountType: accountsTypes.AccountType | undefined;
  balance: number;
  goalsBalance: number;
  availableBalance: number;
  earliestTransactionDate?: string;
};

export const AccountBalancesRecord = Record<AccountBalances>({
  accountId: '',
  accountType: undefined,
  balance: 0,
  goalsBalance: 0,
  availableBalance: 0,
  earliestTransactionDate: undefined,
});

export const ShowBalance = Object.freeze({
  INCLUDE_PENDING: 'BALANCES_WITH_PENDING',
  BANK_REPORTED: 'BALANCES_NOT_PENDING',
});
